import React, {useRef, useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Avatar, Button, Divider, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import { logout } from '../../slices/auth';
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import MenuIcon from '@mui/icons-material/Menu';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.png'
import { getdealerbyid } from '../../slices/dealer';
import { getcustomer } from '../../slices/customer';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#fff',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '25ch',
    },
  },
}));


function DrawerAppBar({show, setShow}) {

  const navigate = useNavigate();

  const [subshow, setSubshow] = useState(false);

  const [headermenushow, setHeaderMenushow] = useState(false);

  const {dealer: dealerData} = useSelector((state) => state.dealer);

  const {customers: cusData} = useSelector((state) => state.customer);

  const menuRef = useRef();

  const user = JSON.parse(localStorage.getItem('user'));

  const dispatch = useDispatch();

  const handleProfile = () =>{
    setSubshow(!subshow);
  }

  const handleLogout = () =>{
    dispatch(logout());
  }

  const handleMenu = () =>{
      setShow(!show)
  };

  const handleHeaderMenu = () =>{
    setHeaderMenushow(true);
  }

  console.log(cusData);

  useEffect(() => {
    if(user){
      dispatch(getdealerbyid())
      dispatch(getcustomer())
    }
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setHeaderMenushow(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if(value.length > 0){
      const mockSuggestions = cusData?.filter(suggestion =>
        suggestion?.first_name?.toLowerCase().includes(value.toLowerCase()) || String(suggestion?.customer_phone_mobile)?.includes(value.toLowerCase()) ||suggestion?.email?.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(mockSuggestions);
    }
    else{
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    navigate(`/customer/view/${suggestion}`);
    setSuggestions([]);
  };


  return (
    <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <AppBar component="nav" sx={{bgcolor: 'secondary.main', color: '#000', py: 0.5, boxShadow:'0px 2px 10px #f1f1f1'}}>
      <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', px: 2}} >
      <Box sx={{display:'flex', justifyContent:'space-between', gap: 6, alignItems:'center'}}>
        <img src={logo} alt='logo' width={50}></img>
        <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={handleMenu}
          >
            <MenuIcon sx={{color:'#fff'}}/>
          </IconButton>
        <Search>
            <SearchIconWrapper>
              <SearchIcon sx={{color:'#fff'}}/>
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search"
              inputProps={{ 'aria-label': 'search' }}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {suggestions.length > 0 && (
        <Box sx={{ position: 'absolute', top: '100%', left: 0, right: 0, bgcolor: 'background.paper', zIndex: 1, boxShadow:'1px 1px 10px #cacaca' }}>
          <List>
            {suggestions.map((suggestion, index) => (
              <ListItem sx={{py: 0}} key={index}>
  <Button variant='text' onClick={() => handleSuggestionClick(suggestion?.id)}>
    <ListItemText primary={suggestion?.first_name} />
  </Button>
</ListItem>
            ))}
          </List>
        </Box>
      )}
          </Search>
          </Box>
        <Toolbar>
        <Button onClick={handleHeaderMenu} size='large' variant='contained'>+</Button>
          { headermenushow && <Box ref={menuRef} sx={{position:'absolute', bgcolor:'#fff', top: '60px', right: '330px', boxShadow:'0px 0px 10px #cacaca', borderRadius: 2, p: 2, minWidth:'200px'}}>
          <Link to='/enquiry/new' style={{textDecoration:'none'}}>
                            <Box sx={{ py: 1, px: 1 }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography sx={{ color: "#000" }}>
                                  + New Enquire
                                </Typography>
                              </div>
                            </Box>
                          </Link>
                          <Link to='/customer/new' style={{textDecoration:'none'}}>
                            <Box sx={{ py: 1, px: 1 }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography sx={{ color: "#000" }}>
                                  + New Customer
                                </Typography>
                              </div>
                            </Box>
                          </Link>
                          <Link to='/usermanagement/createuser' style={{textDecoration:'none'}}>
                            <Box sx={{ py: 1, px: 1 }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography sx={{ color: "#000" }}>
                                  + New User
                                </Typography>
                              </div>
                            </Box>
                          </Link>
          </Box>}
          <Divider orientation="vertical" variant='middle' flexItem sx={{bgcolor:'#b2b2b2', mx: 3}}/>
          <UpdateOutlinedIcon sx={{color:'#fff'}}/>
          <NotificationsOutlinedIcon sx={{color:'#fff', ml: 3}}/>
          <Divider orientation="vertical" variant='middle' flexItem sx={{bgcolor:'#b2b2b2', mx: 3}}/>
          <Button size='large' color='light' variant='text' sx={{fontWeight:'normal', position:'relative'}} onClick={handleProfile}>{user?.organization_name}  <Avatar sx={{mx: 2}} alt="Remy Sharp" src={dealerData?.logo_url}/> <KeyboardArrowDownIcon />
          { subshow && <Box sx={{position:'absolute', bgcolor:'#fff', top: '60px', right: 0, boxShadow:'0px 0px 10px #cacaca', borderRadius: 2, p: 2}}>
          <Link to='/setting' style={{textDecoration:'none'}}>
                            <Box sx={{ py: 2, px: 2 }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                              <AccountCircleIcon sx={{mr: 2}}/>
                                <Typography sx={{ color: "#000" }}>
                                  Profile
                                </Typography>
                              </div>
                            </Box>
                          </Link>
                          <Link style={{textDecoration:'none'}} onClick={handleLogout}>
                            <Box sx={{ py: 2, px: 2 }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                              <LockIcon sx={{mr: 2}}/>
                                <Typography sx={{ color: "#000" }}>
                                  Signout
                                </Typography>
                              </div>
                            </Box>
                          </Link>
          </Box>}
          </Button>
        </Toolbar>
        </Box>
      </AppBar>
    </Box>
  );
}

export default DrawerAppBar;